export const cookiesCustomerRedirectPath = 'customer_redirect_path';
export const cookiesPartnerRedirectPath = 'partner_redirect_path';
export const cookiesListingPortalRedirectPath = 'listing_portal_redirectPath';
export const cookiesFavoriteListings = 'favorite_listings';
export const cookiesIdToken = 'id_token';
